import React from "react";
import { usdt } from "../../../assets/images";
import GetRates from "../../../components/utils/GetRates";
import { NAIRA_WALLET_ENABLED } from "../../../constants/constants";
import { useUser } from "../../../context/user-context";
import { formatAmount } from "../../../utils/formatTime";

type PaymentSource = "NGN" | "USDT";

type PaymentSourceSelectProps = {
  value: PaymentSource;
  onChange: (value: PaymentSource) => void;
};

// Read-only "Pay with" while the Naira wallet is off: utilities are USDT-only.
const UsdtPaymentSource: React.FC = () => {
  const { userDetails } = useUser();
  const usdtBalance = Number(userDetails?.user.deexWalletBalances?.usdt ?? 0);
  const usdtRate = Number(GetRates("USDT") ?? 0);

  return (
    <div className="mt-3 flex items-center justify-between rounded-lg border border-gray-200 px-4 py-3 dark:border-gray-600">
      <div className="flex items-center gap-2">
        <img src={usdt} alt="" className="h-6 w-6" />
        <span className="text-[14px] font-semibold text-gray-900 dark:text-gray-100">
          USDT Wallet
        </span>
      </div>
      <div className="text-right">
        <p className="text-[14px] font-bold text-gray-900 dark:text-gray-100">
          {formatAmount(usdtBalance)} USDT
        </p>
        {!!usdtRate && (
          <p className="text-[12px] font-medium text-gray-500">
            ≈ ₦{formatAmount(usdtBalance * usdtRate)}
          </p>
        )}
      </div>
    </div>
  );
};

// "Pay with" for the utility forms: NGN/USDT toggle, or USDT only when the
// Naira wallet is switched off (NAIRA_WALLET_ENABLED).
const PaymentSourceSelect: React.FC<PaymentSourceSelectProps> = ({
  value,
  onChange,
}) => (
  <>
    <h4 className="text-[14px] font-bold text-gray-500">Pay with</h4>
    {!NAIRA_WALLET_ENABLED ? (
      <UsdtPaymentSource />
    ) : (
      <div className="mt-3 flex gap-3">
        {(["NGN", "USDT"] as PaymentSource[]).map((source) => (
          <button
            key={source}
            type="button"
            onClick={() => onChange(source)}
            className={`h-[40px] flex-1 rounded-lg text-[14px] font-semibold transition ${
              value === source
                ? "bg-secondary_button text-white"
                : "border border-gray-200 bg-transparent text-gray-600 dark:border-gray-600 dark:text-gray-300"
            }`}
          >
            {source === "NGN" ? "Naira Wallet" : "USDT"}
          </button>
        ))}
      </div>
    )}
  </>
);

export default PaymentSourceSelect;
